import { CheckCircle, Circle, Ruler, SealCheck, Star } from "@phosphor-icons/react";
import { photoSrc } from "@/components/AppHeader";

// Office view: what the templator ticked + their note, and the customer's install sign-off.
export const JobFieldRecords = ({ job }) => {
  const cl = job.template_checklist;
  const so = job.install_signoff;
  if (!cl?.ticked?.length && !so) return null;
  return (
    <div className="grid gap-4 lg:grid-cols-2" data-testid="job-field-records">
      {cl?.ticked?.length > 0 && (
        <div className="rounded-lg border border-zinc-800 bg-zinc-900 p-4" data-testid="job-template-checklist">
          <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-purple-300">
            <Ruler size={13} weight="bold" /> Template checklist
            <span className={`ml-auto rounded-full border px-2 py-0.5 text-[9px] ${cl.complete ? "border-emerald-500/40 text-emerald-300" : "border-amber-500/40 text-amber-300"}`}>
              {cl.complete ? "complete" : `${cl.ticked.length} ticked`}
            </span>
          </div>
          <ul className="mt-3 space-y-1.5">
            {(cl.items || cl.ticked).map((item) => {
              const on = cl.ticked.includes(item);
              return (
                <li key={item} className="flex items-center gap-2 text-xs">
                  {on ? <CheckCircle size={15} weight="fill" className="text-emerald-400" /> : <Circle size={15} className="text-zinc-600" />}
                  <span className={on ? "text-zinc-200" : "text-zinc-500"}>{item}</span>
                </li>
              );
            })}
          </ul>
          {cl.note && (
            <div className="mt-3 rounded-md border border-purple-500/30 bg-purple-500/10 p-2 text-xs text-purple-100" data-testid="job-template-note">
              <span className="font-bold uppercase tracking-widest text-[9px] text-purple-300">Templator note · </span>
              {cl.note}
            </div>
          )}
          <div className="mt-2 text-[10px] text-zinc-500">
            {cl.by} · {cl.at ? new Date(cl.at).toLocaleString() : ""}
          </div>
        </div>
      )}
      {so && (
        <div className="rounded-lg border border-zinc-800 bg-zinc-900 p-4" data-testid="job-install-signoff">
          <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-blue-300">
            <SealCheck size={13} weight="bold" /> Customer install sign-off
          </div>
          <div className="mt-3 flex items-start gap-4">
            <img src={photoSrc({ storage_path: so.signature_path })} alt="Customer signature" className="h-20 w-40 rounded-md border border-zinc-800 bg-white object-contain p-1" data-testid="job-signoff-signature" />
            <div className="min-w-0 text-xs">
              <div className="text-sm font-semibold text-zinc-100">{so.signer_name}</div>
              <div className="text-zinc-500">{so.at ? new Date(so.at).toLocaleString() : ""} · installer {so.by}</div>
              {so.rating && (
                <div className="mt-1 flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={n} size={13} weight={n <= so.rating ? "fill" : "regular"} className={n <= so.rating ? "text-amber-400" : "text-zinc-700"} />
                  ))}
                </div>
              )}
              {so.comments && <p className="mt-1 text-zinc-300">"{so.comments}"</p>}
              <div className="mt-1 text-zinc-500">{(so.photo_ids || []).length} completion photo(s) attached</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
